import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
import SelectAsync from 'react-select/async';

export default class CompanyModules extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'company/module',
            data: null,
            loading: true,
            id_to_remove: null,
            page: 1,
            per_page: 30,
            phrase: ''
        };
        this.state.filters = {
            companyId: null,
            moduleId: 0,
            filter: 0
        }
    }
    componentDidMount() {
        this.refreshData();
    }
    setOrganization(e) {
        this.state.filters.companyId = e.value;
        this.state.filters.companyName = e.label;
    }
    renderForm() {
        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">فهرست دسترسی شرکتها به ماژول های سیستم</h3>
                            <div className="nk-block-des text-soft">
                                <p>{this.money(this.state.data.recordsCount)} دسترسی یافت شد</p>
                            </div>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            <NavLink to="/company/module/new/" className="btn btn-primary"><em className="icon ni ni-plus"></em><span>ایجاد دسترسی جدید</span></NavLink>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            <div className="card-inner position-relative card-tools-toggle">
                                <div className="card-title-group">
                                    <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                        <div className="form-inline flex-nowrap gx-3">
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder="نام مالک" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <SelectAsync
                                                    defaultValue={(this.state.filters.companyId != null && this.state.filters.companyId != this.defaultGuid()) ? [{ value: this.state.filters.companyId, label: this.state.filters.companyName }] : null}
                                                    isMulti={false}
                                                    placeholder="همه کسب و کارها"
                                                    noOptionsMessage={({ inputValue }) =>
                                                        inputValue ? "نتیجه‌ای یافت نشد" : null
                                                    }
                                                    loadOptions={(inputValue, callback) => {
                                                        if (inputValue == '') callback(this.state.data.companies);
                                                        var list = this.state.data.companies.filter(f => f.label.includes(inputValue));
                                                        callback(list);
                                                    }
                                                    }
                                                    defaultOptions={this.state.data.companies}
                                                    components={{
                                                        IndicatorSeparator: () => null,
                                                    }}
                                                    onChange={e => this.setOrganization(e)}
                                                />
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.filters.moduleId} onChange={e => this.state.filters.moduleId = parseInt(e.target.value)} className="form-control">
                                                    <option value="0">همه ماژول ها</option>
                                                    {this.state.data.systemModules.map(m => <option value={m.id}>{m.title}</option>)}
                                                </select>
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.filters.filter} onChange={e => this.state.filters.filter = parseInt(e.target.value)} className="form-control">
                                                    <option value="0">بدون فیلتر</option>
                                                    <option value="1">دارای اعتبار</option>
                                                    <option value="2">منقضی شده</option>
                                                </select>
                                            </div>
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> جستجو</button></span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>

                            {this.state.data.recordsCount <= 0 ?
                                <div className="card-inner-group">
                                    <div className="example-alert">
                                        <div className="alert alert-pro alert-warning">
                                            <div className="alert-text">
                                                <h6>توجه</h6>
                                                <p>هیچ دسترسی یافت نشد</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col text-center"><span className="sub-text">عنوان کسب و کار</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">مالک کسب و کار</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">عنوان ماژول</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">تاریخ فعال سازی</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">تاریخ اعتبار</span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text">عملیات</span></div>
                                        </div>
                                        {this.state.data.records.map((record, index) =>
                                            <div className="nk-tb-item">
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">عنوان کسب و کار: </span>
                                                    <span className="sub-text text-center">
                                                        <NavLink to={"/company/module/edit/" + record.id + "/"} title="مشاهده و ویرایش">
                                                            {record.companyName}
                                                        </NavLink>
                                                    </span>
                                                </div>                                                
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">مالک کسب و کار: </span>
                                                    <span className="sub-text text-center">{record.ownerName}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">عنوان ماژول: </span>
                                                    <span className="sub-text text-center">{record.systemModuleTitle}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">تاریخ فعال سازی: </span>
                                                    <span className="sub-text text-center">{record.registerDatePersian}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">تاریخ اعتبار: </span>
                                                    <span className="sub-text text-center">{record.expireDatePersian}</span>
                                                </div>
                                                <div className="nk-tb-col nk-tb-col-tools">
                                                    <ul className="nk-tb-actions gx-1">
                                                        <li>
                                                            <div className="drodown">
                                                                <a href="#" className="dropdown-toggle btn btn-icon btn-trigger" data-bs-toggle="dropdown"><em className="icon ni ni-more-h"></em></a>
                                                                <div className="dropdown-menu dropdown-menu-end">
                                                                    <ul className="link-list-opt no-bdr">
                                                                        <li><NavLink to={"/company/module/edit/" + record.id + "/"}><em className="icon ni ni-eye"></em><span> مشاهده و ویرایش</span></NavLink></li>
                                                                        <li>
                                                                            <a className="hand" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف رکورد">
                                                                                <em className="icon ni ni-cross-fill-c"></em> حذف
                                                                            </a>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            }
                            {this.createPaging()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent()
            ];

        return contents;
    }
}